export default "__VITE_ASSET__BP4_trxY__"